import { Item } from "react-stately";

import type { ComponentPropsWithoutRef, ReactElement, ReactNode } from "react";
import type { ItemProps } from "react-stately";
import type { EmptyObject } from "@skydio/core";
import type { TabsClassNames } from "./Tabs";

export interface TabProps<T extends object = EmptyObject>
  extends Omit<ItemProps<T>, "children">,
    Omit<ComponentPropsWithoutRef<"button">, "children" | "title"> {
  children?: ReactNode | null;
  title?: ReactNode | null;
  titleValue?: string;
  isDisabled?: boolean;
  classNames?: TabsClassNames;
}

export const Tab = Item as (<T extends object>(props: TabProps<T>) => ReactElement<unknown>) & {
  displayName: "Tabs.Tab";
};
Tab.displayName = "Tabs.Tab";
